export enum AuthActionType {

  // Load Token
  LoadToken                     = 'LOAD_TOKEN',
  LoadTokenCompleted            = 'LOAD_TOKEN_COMPLETED',
  LoadTokenFailed               = 'LOAD_TOKEN_FAILED',

  // License Check
  LicenseCheck                  = 'LICENSE_CHECK',
  LicenseCheckCompleted         = 'LICENSE_CHECK_COMPLETED',
  LicenseCheckFailed            = 'LICENSE_CHECK_FAILED',

  // License Update
  LicenseUpdate                 = 'LICENSE_UPDATE',
  LicenseUpdateCompleted        = 'LICENSE_UPDATE_COMPLETED',
  LicenseUpdateFailed           = 'LICENSE_UPDATE_FAILED',

  // Login
  Login                         = 'LOGIN',
  LoginCompleted                = 'LOGIN_COMPLETED',
  LoginFailed                   = 'LOGIN_FAILED',

  // LoginUuid
  LoginUuid                         = 'LOGIN_UUID',
  CheckLoginUuid                    = 'CHECK_LOGIN_UUID',
  LoginUuidCompleted                = 'LOGIN_UUID_COMPLETED',
  LoginUuidFailed                   = 'LOGIN_UUID_FAILED',

  // Logout
  Logout                        = 'LOGOUT',
  LogoutCompleted               = 'LOGOUT_COMPLETED',
  LogoutFailed                  = 'LOGOUT_FAILED',

  // Password Reset
  PasswordReset                 = 'PASSWORD_RESET',
  PasswordResetSent             = 'PASSWORD_RESET_SENT',
  PasswordResetFailed           = 'PASSWORD_RESET_FAILED',
  PasswordResetTokenValidate    = 'PASSWORD_RESET_TOKEN_VALIDATE',
  PasswordResetTokenValid       = 'PASSWORD_RESET_TOKEN_VALID',
  PasswordResetTokenInvalid     = 'PASSWORD_RESET_TOKEN_INVALID',
  PasswordUpdate                = 'PASSWORD_UPDATE',
  PasswordUpdateCompleted       = 'PASSWORD_UPDATE_COMPLETED',
  PasswordUpdateFailed          = 'PASSWORD_UPDATE_FAILED',

}
